import React, { PureComponent, Fragment } from 'react'
import { Menu } from 'antd'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { arrayToTree, queryAncestors } from 'utils'
import store from 'store2'
import { PublicMenuList } from 'layouts/PublicMenuList'

const { SubMenu } = Menu

class SiderMenu extends PureComponent<any> {
  state = {
    openKeys: store.get('openKeys') || [],
  }
  onOpenChange = openKeys => {
    const { menus } = this.props
    const rootSubmenuKeys = menus.filter(_ => !_.menuParentId).map(_ => _.id)
    // const mobileMenus = PublicMenuList.filter(_ => _.type === 0 && _.auth).map(_ => _.id)
    const latestOpenKey = openKeys.find(
      key => this.state.openKeys.indexOf(key) === -1
    )
    let newOpenKeys = openKeys
    if (rootSubmenuKeys.indexOf(latestOpenKey) !== -1) {
      newOpenKeys = latestOpenKey ? [latestOpenKey] : []
    }
    this.setState({
      openKeys: newOpenKeys,
    })
    store.set('openKeys', newOpenKeys)
  }

  generateMenus = data => {
    return data.map(item => {
      if (item.children) {
        return (
          <SubMenu
            key={item.to}
            title={
              <Fragment>
                {/* {item.icon && iconMap[item.icon]} */}
                {item.customIcon ? <item.customIcon iconColor={item.color} /> :
                  item.icon && <i style={{ color: item.color }} className={`fas ${item.icon}`} />}
                <span>{item.label}</span>
              </Fragment>
            }
          >
            {this.generateMenus(item.children)}
          </SubMenu>
        )
      }
      return (
        <Menu.Item key={item.to} icon={item.customIcon ? <i><item.customIcon iconColor={item.color} /></i> : item.icon && <i style={{ color: item.color }} className={`fas ${item.icon}`} />}>
          <Link to={this.props.setCurrentFlg ? '#' : item.to}>
            {/* {item.icon && iconMap[item.icon]} */}
            <span>{item.label}</span>
          </Link>
        </Menu.Item>
      )
    })
  }

  render() {
    const {
      collapsed,
      theme,
      menus,
      location,
      isMobile,
      onCollapseChange,
      isAuthenticated,
      account,
      publicLayout,
      onChangeCurrentMenu
    } = this.props
    const mobileMenus = isAuthenticated ? PublicMenuList.filter(_ => _.type === 0 && _.auth) : PublicMenuList.filter(_ => (_.type === 0 || _.type === account?.type) || (_.type === 0 && !isAuthenticated && !_.auth))
    const menusFull = [...menus, ...PublicMenuList];

    // Generating tree-structured data for menu content.
    const menuTree = arrayToTree(menus, 'id', 'menuParentId')
    // Find a menu that matches the pathname.
    const currentMenu = this.props.currentMenus

    // const currentMenu = menusFull.find(
    //   _ => {
    //     return (_.to && pathToRegexp(_.to).exec(location.pathname)) || (_.subMenus?.includes(location.pathname))
    //       ||
    //       _.subMenus?.find(subItem => {
    //         if (subItem?.includes(":")) {
    //           if (location.pathname.startsWith(subItem.slice(0, subItem.indexOf(":"))))
    //             return true
    //         }
    //       }
    //       ) || false
    //   }

    // )


    // Find the key that should be selected according to the current menu.
    const selectedKeys = currentMenu
      ? queryAncestors(menusFull, currentMenu, 'menuParentId').map(_ => _.to)
      : [];

    const menuProps = collapsed
      ? {}
      : {
        openKeys: this.state.openKeys,
      }
    const collapseFun = () => {
      return isMobile
        ?
        onCollapseChange(true)
        :
        undefined
    }
    return (
      <Menu
        mode="inline"
        theme={theme}
        // onOpenChange={this.onOpenChange}
        selectedKeys={[currentMenu]}
        onClick={function (event) {
          collapseFun();
          onChangeCurrentMenu(event.key);
        }
        }
        {...menuProps}
      >
        {isMobile && !publicLayout && this.generateMenus(mobileMenus)}
        {(isAuthenticated || publicLayout) && this.generateMenus(menuTree)}
      </Menu>
    )
  }
}

export default withRouter(SiderMenu)
